export default "__VITE_ASSET__cc5d79e5__"